import type { ButtonHTMLAttributes } from 'react'
import { cx } from './cx'

export type ButtonVariant = 'primary' | 'secondary' | 'accent' | 'danger' | 'ghost'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: 'sm' | 'md'
}

const BASE =
  'inline-flex items-center justify-center gap-2 rounded-md font-medium transition-colors ' +
  'disabled:cursor-not-allowed disabled:opacity-45'

const VARIANTS: Record<ButtonVariant, string> = {
  primary: 'bg-brand-900 text-white hover:bg-brand-800',
  /** Bronze marks the one consequential action on a screen, never two. */
  accent: 'bg-accent-600 text-white hover:bg-accent-700',
  secondary: 'border border-ink-300 bg-white text-ink-800 hover:bg-ink-50',
  danger: 'border border-red-300 bg-white text-red-800 hover:bg-red-50',
  ghost: 'text-brand-700 hover:bg-brand-50',
}

const SIZES = {
  sm: 'px-2.5 py-1.5 text-sm',
  md: 'px-4 py-2.5 text-sm',
}

export function Button({ variant = 'secondary', size = 'md', className, ...rest }: Props) {
  return <button className={cx(BASE, VARIANTS[variant], SIZES[size], className)} {...rest} />
}
